import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { queryClient } from '../../main';

/**
 * Hook que cancela las consultas pendientes cuando el usuario navega a otra página
 * para evitar errores de tipo "removeChild"
 */
export function usePageNavigation() {
    const location = useLocation();
    
    useEffect(() => {
        // Limpiar consultas con estado "fetching" cuando cambia la ruta
        return () => {
        // Obtener todas las consultas activas
        const queries = queryClient.getQueryCache().findAll({ fetchStatus: 'fetching' });
        
        // Cancelar cada consulta activa
        queries.forEach(query => {
            queryClient.cancelQueries({ queryKey: query.queryKey });
        });
        };
    }, [location.pathname]);
}